import * as Yup from 'yup';
import { InitialCausality } from '../../../../../../shared/types/typifications/initialCausality';

export const initialValues: InitialCausality = {
    active: true,
    category: '',
    consequence: '',
    motive: '',
    motiveDescription: '',
    motiveName: '',
    name: '',
    observationV1: '',
    process: '',
    risk: '',
    riskId: '',
    riskImpact: '',
    sfcMotive: '',
    sfcMotiveClaim: '',
    sfcMotiveIdComplaint: '',
    sfcMotiveIdComplaintOld: '',
    sfcSubaccount: '',
    sfcSubmotive: '',
    submotive1: '',
    submotive2: '',
    submotive3: '',
    submotive4: '',
    subprocess: '',
    typeComplaint: '',
    typeMotive: '',
    typePqr: '',
};

export const validationSchema = (
    hasSubmotive1: boolean,
    hasSubmotive2: boolean,
    hasSubmotive3: boolean,
    hasSubmotive4: boolean
) => {
    const schema: any = {
        category: Yup.string().required('La categoría es obligatoria'),
        consequence: Yup.string().required('La consecuencia es obligatoria'),
        motive: Yup.string().required('El motivo es obligatorio'),
        motiveDescription: Yup.string().required(
            'La descripción del motivo de quejas SFC es obligatoria'
        ),
        motiveName: Yup.string().required(
            'El nombre del motivo de queja SFC es obligatorio'
        ),
        observationV1: Yup.string().required('La observación es obligatoria'),
        process: Yup.string().required('El proceso es obligatorio'),
        product: Yup.string().required('El producto es obligatorio'),
        risk: Yup.string().required('El riesgo es obligatorio'),
        riskId: Yup.string().required('El número de riesgo es obligatorio'),
        riskImpact: Yup.string().required(
            'El impacto del riesgo es obligatorio'
        ),
        sfcMotive: Yup.string().required(
            'El motivo [SECTOR - FASECOLDA] es obligatorio'
        ),
        sfcMotiveClaim: Yup.string().required(
            'El motivo de reclamación SFC es obligatorio'
        ),
        sfcMotiveIdComplaint: Yup.string().required(
            'El código de motivo de quejas SFC es obligatorio'
        ),
        sfcMotiveIdComplaintOld: Yup.string().required(
            'El código anterior de motivo de quejas SFC es obligatorio'
        ),
        sfcSubaccount: Yup.string().required('La subcuenta SFC es obligatoria'),
        sfcSubmotive: Yup.string().required(
            'El submotivo [SECTOR - FASECOLDA] es obligatorio'
        ),
        subprocess: Yup.string().required('El subproceso es obligatorio'),
        typeComplaint: Yup.string().required('El tipo de queja es obligatorio'),
        typeMotive: Yup.string().required('El tipo de motivo es obligatorio'),
        typePqr: Yup.string().required('El tipo de PQR es obligatorio'),
    };

    if (hasSubmotive1)
        schema.submotive1 = Yup.string().required(
            'El submotivo 1 es obligatorio'
        );
    if (hasSubmotive2)
        schema.submotive2 = Yup.string().required(
            'El submotivo 2 es obligatorio'
        );
    if (hasSubmotive3)
        schema.submotive3 = Yup.string().required(
            'El submotivo 3 es obligatorio'
        );
    if (hasSubmotive4)
        schema.submotive4 = Yup.string().required(
            'El submotivo 4 es obligatorio'
        );

    return Yup.object(schema);
};
